import op from 'object-path';

const loginError = {
  methods: {
    handleLoginError(error) {
      const status = op.get(error, 'response.status', 0);
      console.log(error.message);
      return status === 401 ? this.$t('login.wrong_password') : error.message;
    },
  },
};

export default loginError;
